import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: ReactNode;
  desc?: string;
  align?: "left" | "center";
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  action,
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`flex flex-col gap-5 md:flex-row md:items-end md:justify-between ${
        isCenter ? "text-center md:flex-col md:items-center" : ""
      }`}
    >
      <div className={isCenter ? "mx-auto max-w-2xl" : "max-w-2xl"}>
        {eyebrow ? (
          <span className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 font-label text-xs font-medium tracking-wide text-primary-700">
            <i className="ri-sparkling-2-line text-sm" aria-hidden="true"></i>
            {eyebrow}
          </span>
        ) : null}
        <h2 className="text-2xl font-normal leading-snug text-foreground-950 md:text-4xl">{title}</h2>
        {desc ? (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}